import TopCard from './components/TopCard';
import Dashboard from './components/Dashboard';
import { useAnalyticsV3Context } from '../../hooks/useAnalyticsV3Context';
import { useShallow } from 'zustand/react/shallow';
import ResponseMetrics from './components/ResponseMetrics';
import FilterDrawer from './components/filter-drawer/index';
import NoiseReduction from './components/NoiseReduction';
import libraryTheme from 'library/theme';
import { ChakraProvider } from '@chakra-ui/react';
import { AnalyticsV3Container } from '../styles';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function IncidentAnalytics() {
  const tabIndex = useAnalyticsV3Context(useShallow(state => state.tabIndex));
  const resetTab = useAnalyticsV3Context(useShallow(state => state.resetTab));
  const setResponseMetricType = useAnalyticsV3Context(
    useShallow(state => state.setResponseMetricType),
  );
  const resetFilters = useAnalyticsV3Context(useShallow(state => state.resetFilters));
  const setService = useAnalyticsV3Context(useShallow(state => state.setService));
  const queryParams = new URLSearchParams(window.location.search);
  const startDate = queryParams.get('startDate');
  const endDate = queryParams.get('endDate');
  const timezone = queryParams.get('timezone');
  const responseMetricType = queryParams.get('responseMetricType');
  const tabIndexFromUrl = queryParams.get('tabIndex');
  const serviceId = queryParams.get('serviceId');
  const serviceName = queryParams.get('serviceName');

  useEffect(() => {
    if (serviceId && serviceName) {
      setService(serviceId, serviceName);
      return;
    }
    if (!startDate || !endDate || !timezone) {
      resetFilters();
    }
    if (!tabIndexFromUrl) {
      resetTab();
    }
    if (!responseMetricType) {
      setResponseMetricType('mean');
    }
  }, []);

  return (
    <div>
      <TopCard />
      {tabIndex === 1 && <Dashboard />}
      {tabIndex === 2 && <ResponseMetrics />}
      {tabIndex === 3 && <NoiseReduction />}
      <FilterDrawer />
    </div>
  );
}

export const OrgAnalytics = () => {
  const tabIndex = useAnalyticsV3Context(useShallow(state => state.tabIndex));
  const resetTab = useAnalyticsV3Context(useShallow(state => state.resetTab));
  const setResponseMetricType = useAnalyticsV3Context(
    useShallow(state => state.setResponseMetricType),
  );
  const resetFilters = useAnalyticsV3Context(useShallow(state => state.resetFilters));
  const queryParams = new URLSearchParams(window.location.search);
  const startDate = queryParams.get('startDate');
  const endDate = queryParams.get('endDate');
  const timezone = queryParams.get('timezone');
  const responseMetricType = queryParams.get('responseMetricType');
  const tabIndexFromUrl = queryParams.get('tabIndex');

  useEffect(() => {
    if (!startDate || !endDate || !timezone) {
      resetFilters();
    }
    if (!tabIndexFromUrl) {
      resetTab();
    }
    if (!responseMetricType) {
      setResponseMetricType('mean');
    }
  }, []);

  return (
    <ChakraProvider theme={libraryTheme}>
      <AnalyticsV3Container>
        <div style={{ width: '100%' }}>
          <TopCard isOrgAnalytics={true} />
          {tabIndex === 1 && <Dashboard isOrgAnalytics={true} />}
          {tabIndex === 2 && <ResponseMetrics isOrgAnalytics={true} />}
          {tabIndex === 3 && <NoiseReduction isOrgAnalytics={true} />}
          <FilterDrawer isOrgAnalytics={true} />
        </div>
      </AnalyticsV3Container>
    </ChakraProvider>
  );
};
